<template>
  <div>
    <section
      v-for="(subPermObj, subPermIdx) in subPermissions"
      :key="subPermObj.id"
      class="permission-group-item-container"
    >
      <el-checkbox
        v-model="subPermObj.active"
        :disabled="!hasCreateSubPermission"
        @change="handlePermissionToggle(subPermObj.id, subPermIdx, subPermObj.active)"
      >
        <span :style="`margin-left: ${(order - 1) * 1}rem`">
          {{ subPermObj.name }}
        </span>
      </el-checkbox>
      <sub-permission
        v-if="
          subPermObj['sub-permissions'] &&
            subPermObj['sub-permissions'].length > 0
        "
        :subPermissions="subPermObj['sub-permissions']"
        :order="order + 1"
        :parentPermObj="{ id: subPermObj.id, index: subPermIdx }"
        @handleSubPermission="handleSubPermissionToggle"
      />
    </section>
  </div>
</template>

<script>
export default {
  name: 'SubPermission',
  props: ['subPermissions', 'order', 'parentPermObj'],
  methods: {
    handlePermissionToggle (subPermId, subPermIdx, subPermVal) {
      let sub = { id: subPermId, index: subPermIdx, active: subPermVal }
      this.$emit('handleSubPermission', this.parentPermObj, sub)
    },
    handleSubPermissionToggle (...perm) {
      this.$emit('handleSubPermission', this.parentPermObj, ...perm)
    }
  },
  computed: {
    hasCreateSubPermission () {
      return this.$store.getters.checkIfUserHasRequiredPermissions(['system.view_roles', 'system.add_roles'])
    }
  }
}
</script>
<style scoped>
.el-checkbox + .el-checkbox {
  margin-left: 0px;
}
</style>
